/**
 * Generates a formatted vehicle name string based on the provided configuration
 *
 * @param {string} vehicleNameConfiguration - Space-separated string of keys to look up in vehicleData or labels
 * @param {Object} vehicleData - Object containing vehicle data properties
 * @param {Map} labels - Map containing label values for keys not found in vehicleData
 * @returns {string} The formatted vehicle name with resolved values
 *
 * @example
 * // If vehicleNameConfiguration is "NEW make model"
 * // Returns "New Toyota Camry"
 */
export const getVehicleName = (
	vehicleNameConfiguration = '',
	vehicleData = {},
	labels = new Map()
) => {
	return vehicleNameConfiguration
		.split(' ')
		.map((item) =>
			Object.hasOwn(vehicleData, item)
				? vehicleData[item]
				: labels.get(item)
		)
		.filter(Boolean)
		.join(' ');
};
